module.exports = __webpack_public_path__ + "static/media/76.eacb9ac3.jpg";